import { combineReducers } from 'redux'

import ordersReducer from './ordersReducer'
import notificationsReducer from './notificationsReducer'
import authReducer from './authReducer'
import usersReducer from './usersReducer'
import chatReducer from './chatReducer';
import crudReducer from './crudReducer'
import locationReducer from './locationReducer'
import cartReducer from './cartReducer'
import packageReducer from './packageReducer'
import purchaseReducer from './purchaseReducer'
import productReducer from './productReducer'
import analyticsReducer from './analyticsReducer'
import dailysalesReducer from './dailysalesReducer'
import wastableReducer from './wastableReducer'
import monthlyInventoryReducer from './monthlyInventoryReducer'
import wastedmenu_data from './wastedmenuReducer'
import pullOutReducer from './pullOutReducer'



const rootReducer = combineReducers({
    crudReducer,
    products:productReducer,
    packages:packageReducer,
    purchases:purchaseReducer,
    orders: ordersReducer,
    locations:locationReducer,
    cart:cartReducer,
    notifications:notificationsReducer,
    auth:authReducer,
    users:usersReducer,
    chat:chatReducer,
    analytics:analyticsReducer,
    dailysales:dailysalesReducer,
    wastable:wastableReducer,
    wastedmenu:wastedmenu_data,
    monthlyInventory:monthlyInventoryReducer,
    pullOut:pullOutReducer
})

export default rootReducer
